import React, { useState } from "react";
import Home from "./Home";
import SignUpModal from "../components/common/SignUpModal";
import { STUDIO } from "../components/common/consts";

export default function ResetStudio() {
  const [openModel, setOpenModal] = useState(true);

  return (
    <>
      <SignUpModal loginFor={STUDIO} resetPas isOpen={openModel} setOpen={setOpenModal} />
      <Home />
    </>
  );
}
